/**
 * Formats an order date into a readable format.
 * Example: "September 21, 2026" / "21 septembre 2026" (depends on locale)
 *
 * Expected input: "DD/MM/YYYY" (e.g. "20/04/2026"), parsed as UTC.
 */

export const formatOrderDate = (dateString, locale = 'en-US') => {
    if (!dateString) return ''

    const [day, month, year] = dateString.split('/')

    const date = new Date(Date.UTC(
        Number(year),
        Number(month) - 1,
        Number(day)
    ))

    return new Intl.DateTimeFormat(locale, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        timeZone: 'UTC'
    }).format(date)
}
